<footer class="footer">
  <div class="center">
    <p class="p5" *ngIf="info">{{ info.copyright }}</p>
  </div>
</footer>
